import React, { useState } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { ReactComponent as PlusIcon } from "feather-icons/dist/icons/plus.svg";
import { ReactComponent as MinusIcon } from "feather-icons/dist/icons/minus.svg";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-16 lg:py-20`;

const TwoColumn = tw.div`flex`;
const Column = tw.div``;

const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  props.imageContain ? tw`bg-contain bg-no-repeat` : tw`bg-cover`,
  props.imageShadow ? tw`shadow` : tw`shadow-none`,
  tw`hidden lg:block rounded h-144 bg-center`
]);

const FAQContent = tw.div`lg:ml-12`;
const Subheading = tw(SubheadingBase)`mb-4 text-center lg:text-left`;
const Heading = tw(SectionHeading)`lg:text-left`;
const Description = tw.p`max-w-xl text-center mx-auto lg:mx-0 lg:text-left lg:max-w-none leading-relaxed text-sm sm:text-base lg:text-lg font-medium mt-4 text-secondary-100`;

const FAQSContainer = tw.dl`mt-12`;
const FAQ = tw.div`cursor-pointer mt-8 select-none border lg:border-0 px-8 py-4 lg:p-0 rounded-lg lg:rounded-none`;
const Question = tw.dt`flex justify-between items-center`;
const QuestionText = tw.span`text-lg lg:text-xl font-semibold`;
const QuestionToggleIcon = styled.span`
  ${tw`ml-2 bg-primary-500 text-gray-100 p-1 rounded-full group-hover:bg-primary-700 group-hover:text-gray-200 transition duration-300`}
  svg {
    ${tw`w-4 h-4`}
  }
`;
const Answer = motion(tw.dd`pointer-events-none text-sm sm:text-base leading-relaxed`);

export default ({
  subheading = "FAQ",
  heading = "Pertanyaan Umum",
  description = "Berikut adalah beberapa pertanyaan yang sering diajukan terkait perjalanan Umroh dan Haji. Jika Anda memiliki pertanyaan lain, jangan ragu untuk menghubungi kami melalui formulir kontak.",
  imageSrc = "https://images.unsplash.com/photo-1579427421635-a0015b804b2e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1024&q=80",
  imageContain = false,
  imageShadow = true,
  faqs = null
}) => {
  const defaultFaqs = [
    {
      question: "Bagaimana cara mendaftar paket Umroh atau Haji?",
      answer:
        "Anda dapat mendaftar melalui website kami atau langsung menghubungi kantor cabang terdekat. Tim kami akan membantu proses pendaftaran, termasuk memilih paket, jadwal keberangkatan, dan kelengkapan dokumen."
    },
    {
      question: "Apakah biaya paket sudah termasuk tiket pesawat dan akomodasi?",
      answer:
        "Ya, paket Umroh dan Haji kami sudah termasuk tiket pesawat, akomodasi hotel sesuai paket, transportasi di tanah suci, serta beberapa fasilitas pendukung lainnya. Biaya tambahan hanya untuk kebutuhan pribadi atau layanan opsional."
    },
    {
      question: "Apakah tersedia pendampingan selama perjalanan?",
      answer:
        "Setiap rombongan akan didampingi oleh pembimbing berpengalaman yang siap membantu jamaah selama ibadah dan perjalanan wisata. Pendampingan mencakup manasik, koordinasi transportasi, dan tips ibadah yang nyaman."
    },
    {
      question: "Bagaimana jika ada perubahan jadwal atau pembatalan?",
      answer:
        "Perubahan jadwal atau pembatalan dapat dilakukan sesuai syarat dan ketentuan paket. Tim kami akan memberikan informasi lengkap mengenai prosedur, refund, atau opsi penjadwalan ulang agar jamaah tetap nyaman."
    },
    {
      question: "Apakah ada fasilitas khusus untuk jamaah lansia atau difabel?",
      answer:
        "Kami menyediakan fasilitas pendukung seperti transportasi yang nyaman, penginapan dekat lokasi ibadah, dan bantuan khusus untuk jamaah lansia atau difabel agar perjalanan tetap aman dan menyenangkan."
    }
  ];


  if (!faqs || faqs.length === 0) faqs = defaultFaqs;

  const [activeQuestionIndex, setActiveQuestionIndex] = useState(null);

  const toggleQuestion = questionIndex => {
    if (activeQuestionIndex === questionIndex) setActiveQuestionIndex(null);
    else setActiveQuestionIndex(questionIndex);
  };

  return (
    <Container>
      <Content>
        <TwoColumn>
          <Column tw="hidden lg:block w-5/12 flex-shrink-0">
            <Image imageContain={imageContain} imageShadow={imageShadow} imageSrc={imageSrc} />
          </Column>
          <Column>
            <FAQContent>
              {subheading ? <Subheading>{subheading}</Subheading> : null}
              <Heading>{heading}</Heading>
              <Description>{description}</Description>
              <FAQSContainer>
                {faqs.map((faq, index) => (
                  <FAQ
                    key={index}
                    onClick={() => {
                      toggleQuestion(index);
                    }}
                    className="group"
                  >
                    <Question>
                      <QuestionText>{faq.question}</QuestionText>
                      <QuestionToggleIcon>
                        {activeQuestionIndex === index ? <MinusIcon /> : <PlusIcon />}
                      </QuestionToggleIcon>
                    </Question>
                    <Answer
                      variants={{
                        open: { opacity: 1, height: "auto", marginTop: "16px" },
                        collapsed: { opacity: 0, height: 0, marginTop: "0px" }
                      }}
                      initial="collapsed"
                      animate={activeQuestionIndex === index ? "open" : "collapsed"}
                      transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
                    >
                      {faq.answer}
                    </Answer>
                  </FAQ>
                ))}
              </FAQSContainer>
            </FAQContent>
          </Column>
        </TwoColumn>
      </Content>
    </Container>
  );
};
